import * as React from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { Box, Text } from '@wix/design-system';
import { useComponentsTranslations } from '../../providers/ComponentsTranslationsProvider';
dayjs.extend(duration);
const initialValue = dayjs.duration(0);
const Separator = ({ className, separatorProps }) => (React.createElement(Text, { className: className, size: "small", ...separatorProps }, ":"));
const TimePart = ({ value, label, dataHook, classNames, timePartProps, timePartLabelProps, }) => {
    const formattedValue = value < 10 ? `0${value}` : value;
    const { t } = useComponentsTranslations();
    return (React.createElement(Box, { direction: "vertical", align: "center", className: classNames.timePartWrapper },
        React.createElement(Text, { dataHook: dataHook, className: classNames.timePart, ...timePartProps }, formattedValue),
        React.createElement(Text, { className: classNames.label, size: "tiny", ...timePartLabelProps }, t(label))));
};
export const Countdown = ({ endDate, currentDate, classNames = {
    timePart: '',
    label: '',
    separator: '',
}, timePartProps = {}, separatorProps = {}, timePartLabelProps = {}, }) => {
    const [timeLeft, setTimeLeft] = React.useState(dayjs.duration(dayjs(endDate).diff(dayjs(currentDate))));
    React.useEffect(() => {
        const timeOut = setTimeout(() => setTimeLeft(timeLeft.subtract(1, 's')), 1000);
        return () => {
            clearTimeout(timeOut);
        };
    }, [timeLeft]);
    if (timeLeft.days() >= 1) {
        return null;
    }
    const counter = timeLeft.asMilliseconds() <= 0 ? initialValue : timeLeft;
    return (React.createElement(Box, { dataHook: "countdown", className: classNames.wrapper },
        React.createElement(Box, null,
            React.createElement(TimePart, { dataHook: "countdown-hours", value: counter.hours(), label: "sale.countdown.hours" /* TimePartLabelKey.Hours */, classNames: classNames, timePartProps: timePartProps, timePartLabelProps: timePartLabelProps }),
            React.createElement(Separator, { className: classNames.separator, separatorProps: separatorProps })),
        React.createElement(Box, null,
            React.createElement(TimePart, { dataHook: "countdown-minutes", value: counter.minutes(), label: "sale.countdown.minutes" /* TimePartLabelKey.Minutes */, classNames: classNames, timePartProps: timePartProps, timePartLabelProps: timePartLabelProps }),
            React.createElement(Separator, { className: classNames.separator, separatorProps: separatorProps })),
        React.createElement(TimePart, { dataHook: "countdown-seconds", value: counter.seconds(), label: "sale.countdown.seconds" /* TimePartLabelKey.Seconds */, classNames: classNames, timePartProps: timePartProps, timePartLabelProps: timePartLabelProps })));
};
//# sourceMappingURL=Countdown.js.map